const es = {
    serviceCall: 'El proveedor de servicios puede llamar',
    heading_request:        '¿Cuáles son los detalles de su solicitud de trabajo?',
    valid_question1: '¿Algún otro detalle que veas relevante?',
    valid_question2:        'Si no proporciona suficiente información. esto afectará la cantidad de cotizaciones que recibirá.',
    valid_question3: 'Debe ingresar 100 letras por lo menos.',
    image_question: '¿Le gustaría agregar imágenes?',
    where_location: 'Dónde ? (Ubicación del trabajo)',
    location_validation:        'No podemos usar tu ubicación. Busque la ciudad o ingrese manualmente',
    userMyLocation: 'USAR MI UBICACIÓN',
    enterCity: 'Ingrese el nombre de su ciudad',
    when_job: 'Cuándo ? (fecha del trabajo)',
    answer_question: '¿Te gustaría responder a estas preguntas?',
    inputAnswer: 'Ingrese su respuesta aquí...',
    enterPhone: 'Introduce tu teléfono',
    phoneDescription:        'Nuestros profesionales pueden contactarlo más rápido si selecciona "El proveedor de servicios puede llamar".',
    enterPhoneNumber: 'Ingrese su número telefónico',
    sendRequest: 'ENVIAR PETICIÓN',
    alert_image: 'Sube al menos una imagen.',
    alert_description: 'Por favor ingrese la descripción.',
    alert_address: 'Por favor ingrese su dirección.',
    alert_one_option: 'Por favor selecciona una opcion.',
    alert_pick_date: 'Favor de recoger fecha.',
    alert_answer: 'Por favor conteste la pregunta',
    alert_phone: 'Por favor ingrese el número de teléfono.',
    request_success_msg: '¡Felicidades! ¡Has solicitado con éxito!',
    alert_close_description:        'Puede obtener cotizaciones gratis respondiendo algunas preguntas más.',
    go_on: 'CONTINUAR',
    quit: 'ABANDONAR',
    servicesCompanyReady: "Empresa de servicios lista",
    allow_contacts: "mostrar mi número de teléfono",
    dont_disturbme: "no me molestes",
    only_phone: "Contáctame solo por teléfono",
    only_offers: "Enviarme solo ofertas",
    only_whatsapp: "Contactame solo por whatsapp",
    kEmailNullError: "Por favor introduzca su correo electrónico",
    kInvalidEmailError:        "Por favor introduzca un correo electrónico válido",
    kPassNullError: "Por favor, introduzca su contraseña",
    kConfirmPasswordError: "Contraseña no coincidente",
    kShortPassError:        "La contraseña es demasiado corta, al menos 8 caracteres",
    kMatchPassError: "Las contraseñas no coinciden",
    kNameNullError: "Por favor ingresa tu nombre completo",
    kPhoneNumberNullError:        "Por favor, introduzca su número de teléfono",

    email: 'Correo electrónico',
    password: 'Clave',
    pleaseendteryouremail:        'Por favor introduzca su correo electrónico',
    pleaseenteryourpassword: 'Por favor, introduzca su contraseña',

    confirmpassword: 'Confirmar contraseña',

    name: 'Nombre',

    Congratulation: 'Felicitaciones',
    requestPriority: 'Solicitud de prioridad',

    free: 'Gratis',
    high: "alto",

    noSearchResult: 'Sin resultado de búsqueda',
    inputThree: 'Por favor ingrese al menos 3 letras',

    selected_city: 'Ciudad(es) seleccionada(s)',
    specificTime: 'Tiempo específico (dentro de tres semanas)',
    inTwoMonth: 'En dos meses',
    inSixMonth: 'en seis meses',
    onlyPrice: 'Solo busco precio',
    flexibleTime: 'Flexible',


    asap: 'Lo antes posible',

    lab_continue: 'Continuar',
//CUSTOM
mainheading: '¿Qué tipo de servicios estás buscando?',
back: 'Atrás',
serviceErrHead: 'Servicio vacío',
serviceError: 'Seleccione un servicio que esté buscando para continuar.',

requiredField: "Campo requerido",
requireDesc: 'Este campo es obligatorio.'


}

export default es;